import {create } from 'zustand';
import {devtools} from "zustand/middleware";
import {User} from "@/api/dto/dto";

export type AuthState = {
  attestationCheck: boolean | null;
  setAttestationCheck: (val: boolean) => void;
  phoneVerificationCheck: boolean | null;
  setPhoneVerificationCheck: (val: boolean) => void;
  currentUser: User | null;
  setCurrentUser: (val: User) => void;
  returnToRoute: string | null;
  setReturnToRoute: (val: string) => void;
  resetState: () => void;
}

export const useAuthStore = create<AuthState>()(
  devtools(
    (set) => ({
      attestationCheck: null,
      setAttestationCheck: (val: boolean) => set({attestationCheck: val }),
      phoneVerificationCheck: null,
      setPhoneVerificationCheck: (val: boolean) => set({phoneVerificationCheck: val }),
      currentUser: null,
      setCurrentUser: (val: User) => set({currentUser: val }),
      returnToRoute: null,
      setReturnToRoute: (val: string) => set({returnToRoute: val }),
      resetState: () => set({attestationCheck: null, phoneVerificationCheck: null, currentUser: null}),
    }),
    { name: 'authStore', enabled: ['local', 'dev', 'qa'].includes(process.env.REACT_APP_ENV || 'prod')},
  ),
);
